// Componente Register - Página principal do Register
import React, { useState, useCallback } from "react";
import style from "./register.module.css";
import Header from "../../components/header/header.js";
import NavBar from "../../components/nav-bar/nav-bar.js";
import BodyRegister from "./body-register.js";

/**
 * Componente Register - Página principal do Register
 * Gerencia o layout geral (Header, NavBar, BodyRegister)
 * e o estado do menu lateral
 */
function Register() {
  // Estado para controlar abertura/fechamento do menu lateral
  const [menuBoard, setMenuBoard] = useState(false);

  /**
   * Handler para alternar estado do menu lateral
   * @param {boolean} value - Novo estado do menu
   */
  const handleMenuBoard = useCallback((value) => {
    setMenuBoard(value);
  }, []);

  return (
    <div className="main">
      <Header menu={handleMenuBoard} />

      <div className={style["body"]}>
        {/* NavBar lateral (colapsável) */}
        <div
          className={menuBoard ? style["navbar-open"] : style["navbar-close"]}
        >
          <NavBar menu={menuBoard} navOpen={handleMenuBoard} />
        </div>

        {/* Corpo principal do Register */}
        <div className={style["body-body"]}>
          <BodyRegister />
        </div>
      </div>
    </div>
  );
}

export default Register;
